import { ADMIN_DEBUGGER_LS_KEY } from '../../constants/shared-constants';
import { LocalStorage } from '../../utils/core/BrowserStorage';

export const isDebuggerEnabled = LocalStorage.getItem(ADMIN_DEBUGGER_LS_KEY) === 'true';
